'use es6';

import { combineReducers } from 'redux';
import ActionTypes from '../constants/ActionTypes';
import RequestStatusTypes from '../constants/RequestStatusTypes';

var requestStatus = function requestStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : RequestStatusTypes.UNINITIALIZED;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.PROVIDER_NAMES_REQUESTED:
      return RequestStatusTypes.PENDING;

    case ActionTypes.PROVIDER_NAMES_RECEIVED:
      return RequestStatusTypes.SUCCEEDED;

    case ActionTypes.PROVIDER_NAMES_FAILED:
      return RequestStatusTypes.FAILED;

    default:
      return state;
  }
};

var names = function names() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.PROVIDER_NAMES_RECEIVED:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  names: names,
  requestStatus: requestStatus
});